<h2 class="h2">Multiple Events</h2>

<div *ngIf="!showPreview" [formGroup]="multiEventForm" class="event-form">

  <p>Repeat <strong>{{originalEvent.name}}</strong>:</p>

  <div class="d-flex flexAlign--center flexWrap-wrap">
    <mat-form-field class="col__">
      <mat-label>Start times ({{ originalEvent.timeZone | timezone }})</mat-label>
      <mat-chip-grid #chipList>
        <mat-chip-row *ngFor="let startTime of hoursSelections" [removable]="startTime !== originalTime"
          (removed)="removeStartTime(startTime)"
          [matTooltip]="startTime !== originalTime ? undefined : 'Go back to change original start time'">
          {{startTime | timeFormat}}
          <mat-icon matChipRemove fontSet="far" fontIcon="fa-times" *ngIf="startTime !== originalTime"></mat-icon>
        </mat-chip-row>
        <input matInput type="time" placeholder="Add time..." [matChipInputFor]="chipList" class="pl-0050"
          [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addStartTime($event)">
      </mat-chip-grid>
    </mat-form-field>
  </div>

  <div class="d-flex flexAlign--start flexWrap-wrap flexJustify-between--xs flexJustify-start--xs">
    <!-- <div class="spacerRight">Every</div> -->
    <mat-form-field class="interval-input spacerRight">
      <mat-label>Every</mat-label>
      <input matInput type="number" min="1" formControlName="interval">
      <app-input-error [formControlItem]="multiEventForm.controls['interval']"></app-input-error>
    </mat-form-field>
    <mat-form-field class="no-label spacerRight interval-units">
      <mat-label>Interval</mat-label>
      <mat-select formControlName="intervalType">
        <mat-option value="day">day{{multiEventForm.value.interval > 1 ? 's' : ''}}</mat-option>
        <mat-option value="week">week{{multiEventForm.value.interval > 1 ? 's' : ''}}</mat-option>
        <mat-option value="month">month{{multiEventForm.value.interval > 1 ? 's' : ''}}</mat-option>
        <mat-option value="year">year{{multiEventForm.value.interval > 1 ? 's' : ''}}</mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="multiEventForm.value.intervalType=='week'" class="days-of-week d-inline-block mb-0050">
      <mat-button-toggle-group name="daysOfWeek" multiple formControlName="selectedDays">
        <mat-button-toggle *ngFor="let day of daysOfWeek" [value]="day.value"
          [disabled]="day.disabled">{{day.label}}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div *ngIf="multiEventForm.value.intervalType=='month'" class="month-opts">
      <mat-form-field class="w-100">
        <mat-select formControlName="monthIntervalType">
          <mat-option *ngIf="this.originalDate !== 31" value="date">on day {{originalStartDate | date:'d'}}</mat-option>
          <mat-option *ngIf="isLastDayOfMonth" value="lastDay">on last day of month</mat-option>
          <mat-option value="week">on the {{originalWeekAndDay}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <mat-form-field class="date-field">
    <mat-label>End date</mat-label>
    <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" [min]="originalStartDate">
    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #endDatePicker>
    </mat-datepicker>
    <app-input-error [formControlItem]="multiEventForm.controls['endDate']"></app-input-error>
  </mat-form-field>

  <app-error-notification [errors]="errorMessages"></app-error-notification>

  <div class="row dual-btn-row mt-0200">
    <button class="btn btn--white floatLeft" (click)="onBack.emit()">Back</button>

    <button class="btn floatRight" (click)="preview()">Preview</button>
  </div>
</div>

<div *ngIf="showPreview">

  <p><strong>{{originalEvent.name}}</strong> will be created for the following dates/times <span class="nowrap">({{ originalEvent.timeZone | timezone }}):</span></p>
  <div class="d-flex flexDirection--col mb-0100">
    <mat-checkbox *ngFor="let eventCopy of eventCopies" [(ngModel)]="eventCopy.selected">{{eventCopy.label}}
    </mat-checkbox>
  </div>
  <div class="row dual-btn-row mt-0200">
    <button class="btn btn--white floatLeft" (click)="showPreview = false">Back</button>

    <button class="btn floatRight" (click)="createEvents()">Create selected events</button>
  </div>
</div>
